import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "top-bar-left" }
const _hoisted_3 = {
  href: "/",
  class: "top-bar-logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "top-bar-middle" }
const _hoisted_6 = { class: "top-bar-right" }
const _hoisted_7 = { class: "top-bar__functionals" }
const _hoisted_8 = { class: "top-bar__mobile-conent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLinks = _resolveComponent("MainLinks")!
  const _component_ContrastSwitcher = _resolveComponent("ContrastSwitcher")!
  const _component_FontsizeSwitcher = _resolveComponent("FontsizeSwitcher")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_MobileMenu = _resolveComponent("MobileMenu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/img/logo_2026.svg'),
          class: "top-bar-logo-image",
          alt: "ITS logo"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MainLinks)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ContrastSwitcher),
        _createVNode(_component_FontsizeSwitcher),
        _createVNode(_component_LanguageSwitcher)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_MobileMenu),
        _createVNode(_component_v_btn, {
          onClick: _ctx.toggleMobileMenu,
          class: "top-bar__menu-switcher",
          variant: "text",
          title: "Menu"
        }, {
          default: _withCtx(() => [
            (!_ctx.showMobileMenu)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  size: "35"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-menu")
                  ])),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  size: "35"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-close")
                  ])),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}